import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

const Section8 = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const initialType = queryParams.get('type') || '1';

  const [selectedTab, setSelectedTab] = useState(initialType);
  const [displayedTab, setDisplayedTab] = useState(initialType);
  const [animationClass, setAnimationClass] = useState('fade-in');

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const typeFromUrl = params.get('type') || '1';
    if (typeFromUrl !== selectedTab) {
      setSelectedTab(typeFromUrl);
    }
  }, [location.search, selectedTab]);

  useEffect(() => {
    if (selectedTab !== displayedTab) {
      // Step 1: Fade-out and slide out to the left
      setAnimationClass('fade-out');
      const fadeOutTimer = setTimeout(() => {
        // Step 2: Update content and position it off-screen right
        setDisplayedTab(selectedTab);
        setAnimationClass('pre-slide');
        // Step 3: Trigger fade-in and slide in from the right
        const slideInTimer = setTimeout(() => {
          setAnimationClass('fade-in');
        }, 50); // A short delay to allow the browser to apply the "pre-slide" state
        return () => clearTimeout(slideInTimer);
      }, 300); // Matches the fade-out transition duration
      return () => clearTimeout(fadeOutTimer);
    }
  }, [selectedTab, displayedTab]);

  return (
    <div
      style={{
        minHeight: '680px',
        backgroundColor: '#000',
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-12 py-5">
            <div className="mt-5" style={{ maxWidth: '450px' }}>
              <h3 className="title white mt-5">
                {t('titleSpecSection')}{' '}
                <span className="gradient-text">{t('redefinesSec')}</span>{' '}
              </h3>
              <p className="text white mt-4">
                {t('ecoEnergyTrailerService' + displayedTab)}
              </p>
            </div>
            <div className="row">
              <div className="col-5">
                <div className="row">
                  <div className="col-3">
                    <p className="title white mt-5">{t('height')}</p>
                  </div>
                  <div className="col-7 mt-2">
                    {' '}
                    <p className="text white mt-5">{t('interiorHeight')}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    <p className="title white mt-2">{t('width')}</p>
                  </div>
                  <div className="col-7 mt-2">
                    {' '}
                    <p className="text white mt-2">{t('interiorWidth')}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    <p className="title white mt-2">{t('depth')}</p>
                  </div>
                  <div className="col-8 mt-2">
                    {' '}
                    <p className="text white mt-2">{t('interiorDepth')}</p>
                  </div>
                </div>
              </div>
              <div className="col-7">
                <div className="row">
                  <div className="col-5">
                    <p className="title white mt-5">
                      {t('volume')}
                      <span style={{ fontSize: '14px' }}>
                        {t('unitCubicFeet')}
                      </span>
                    </p>
                  </div>
                  <div className="col-7 mt-2">
                    {' '}
                    <p className="text white mt-5">{t('interiorVolume')}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-5">
                    <p className="title white mt-2">
                      {t('maxLoad')}
                      <span style={{ fontSize: '14px' }}>
                        {t('unitPounds')}
                      </span>
                    </p>
                  </div>
                  <div className="col-6 mt-2">
                    <p className="text white mt-2">{t('maxLoadLabel')} </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 hide-mobile">
            <img
              src="./img/blue-print.jpg"
              height={680}
              alt="blue-print"
              style={{
                zIndex: 100,
                position: 'relative',
                width: 'auto',
                marginLeft: '60px',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section8;
